import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';
import * as vehicleSelectors from '@makemydeal/dr-dash-store/selectors/vehicleSelectors';
import { SlideOutWrapper } from './SlideOutWrapper';
import { ChangeVehicleActivity } from '@makemydeal/dr-activities-change-vehicle';
import { useInterstateTheme } from '@interstate/components/InterstateThemeProvider';
import { ThemeProvider } from 'styled-components';
import { FULL_SCREEN_SLIDE_OUT_WIDTH } from '@makemydeal/dr-shared-ui-utils';
import type { SlideOutComponentProps } from '../../types';

export const ChangeVehicleSlideOut = ({ isOpen, onClose }: SlideOutComponentProps) => {
    const theme = useInterstateTheme();

    const isVehicleSuccessfullySwitched = useSelector(vehicleSelectors.showVehicleChangeSnackBar);

    useEffect(() => {
        if (isVehicleSuccessfullySwitched) {
            onClose();
        }
    }, [isVehicleSuccessfullySwitched]);

    return (
        <SlideOutWrapper
            title={'Change Vehicle'}
            isOpen={isOpen}
            onClose={onClose}
            panelWidth={FULL_SCREEN_SLIDE_OUT_WIDTH}
            testId="tab-slideout-change-vehicle"
        >
            <ThemeProvider theme={theme}>
                <ChangeVehicleActivity isInsideSlideOut={true} showReturnToOffer={true} onCancel={onClose} />
            </ThemeProvider>
        </SlideOutWrapper>
    );
};
